import en from './en/crowdfunding'
import br from './en/crowdfunding'
export default {
  en,
  br
}